export const DISPLAY_POP_UP_ALL_TIME = 'all_time';
export const DISPLAY_POP_UP_DURING_BUSINESS = 'during_business';
